// extracted by mini-css-extract-plugin
export default {"mainSpinnerWrapper":"spinner_mainSpinnerWrapper__zQu1h"};